import { render, staticRenderFns } from "./ParameterTable.vue?vue&type=template&id=b7070a12&"
import script from "./ParameterTable.vue?vue&type=script&lang=js&"
export * from "./ParameterTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports